import React from 'react';
import { Flex, Box } from '../Rebass';
import Heading from '../Heading';
import Text from '../Text';
import { CardProps } from './types';
import Meta from '../Meta';
import styled from '@emotion/styled';
import { cardHeadlineStyle, cardWrapperStyle } from './common';

const CardWrapper = styled(Flex)(cardWrapperStyle);
const StyledHeading = styled(Heading)(cardHeadlineStyle);

const CardFeatured = (props: CardProps) => {
  const {
    headline = '',
    description = '',
    meta = [],
    image = null,
    bg = 'transparent',
    padding = {},
    highlight = '',
    isLink = false,
  } = props;
  return (
    <CardWrapper
      flexDirection={['column', 'column', 'row']}
      bg={bg}
      {...padding}
    >
      <Box
        mr={[8]}
        width={[1, 1, 0.6]}
        flex="1 0 auto"
        sx={{ position: 'relative' }}
      >
        {highlight && (
          <Flex
            sx={{
              position: 'absolute',
              top: '12px',
              left: '12px',
              bg: 'white',
              zIndex: 1,
              borderRadius: '4px',
              padding: '4px 5px',
              maxWidth: '50%',
            }}
          >
            <Text
              size="extraSmall"
              sx={{ textTransform: 'uppercase', overflowWrap: 'break-word' }}
            >
              {highlight}
            </Text>
          </Flex>
        )}
        {image}
      </Box>
      <Box pt={[3]}>
        {Boolean(meta.length) && (
          <Box mb={[2]}>
            <Meta meta={meta} size="small" />
          </Box>
        )}
        <Box mb={[3]}>
          <StyledHeading className="card-headline" isLink={isLink} size="h2">
            {headline}
          </StyledHeading>
        </Box>
        <Box>
          <Text size="body" color="textDark" lineHeight="1.5">
            {description}
          </Text>
        </Box>
      </Box>
    </CardWrapper>
  );
};

export default CardFeatured;
